import { useEffect } from "react";
import { GameTypeEnum } from "../enums/index";

import { fetchConfig } from "../store/config-slice";
import { useAppDispatch, useAppSelector } from "../store/hooks";

interface UseFetchConfig {
  isBettingEnabled: boolean;
  isConnectionLost: boolean;
}

export const useFetchConfig = (): UseFetchConfig => {
  const isBettingEnabled = useAppSelector(
    (state) => state.config.isBettingEnabled
  );
  const isConnectionLost = useAppSelector(
    (state) => state.config.isConnectionLost
  );
  const gameType = useAppSelector((state) => state.config.gameType);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (
      (!isBettingEnabled || isConnectionLost) &&
      gameType !== GameTypeEnum.PRESENTATION
    ) {
      interval = setInterval(() => {
        dispatch(fetchConfig());
      }, 20000);
    } else if (interval) {
      clearInterval(interval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isBettingEnabled, isConnectionLost, gameType, dispatch]);

  return {
    isBettingEnabled,
    isConnectionLost,
  };
};
